export interface BookingDiscountLookup {
  id: number;
  name: string;
}

interface DiscountLookupShape {
  id: number;
  name: string;
}

export const mapDiscountToBookingDiscountLookup = (
  discount: DiscountLookupShape | undefined | null
): BookingDiscountLookup | undefined => {
  if (!discount) {
    return undefined;
  }

  return {
    id: discount.id,
    name: discount.name,
  };
};
